

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// ADDCOUNTRYPOST
// ADDCOUNTRYPOST
const ADDCOUNTRYPOST= createAsyncThunk(
  "AddCountryPost/AddCountryPost",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const AddCountryPostSlice = createSlice({
  name: "AddCountryPostSlice",
  initialState: {
    AddCountryPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfAddCountryPost: (state) => {
        state.AddCountryPost.loading = false
        state.AddCountryPost.error = false
        state.AddCountryPost.data = []
        state.AddCountryPost.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDCOUNTRYPOST.fulfilled, (state, action) => {
      state.AddCountryPost = {
        ...state.AddCountryPost,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDCOUNTRYPOST.pending, (state, action) => {
      state.AddCountryPost = {
        ...state.AddCountryPost,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDCOUNTRYPOST.rejected, (state, action) => {
      state.AddCountryPost = {
        ...state.AddCountryPost,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const AddCountryPostAction = {
    ADDCOUNTRYPOST,
};

export { AddCountryPostAction };
export default AddCountryPostSlice.reducer;
export const {setInitialStateOfAddCountryPost} = AddCountryPostSlice.actions